import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const companyGameState = {
  companyList: null,
  companyGame: null,
  gameDetail: null,
};

export const companyGameSlice = createSlice({
  name: "companyGame",
  initialState: companyGameState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },

    companyListFetched: (state, action) => {
      state.listLoading = false;
      state.companyList = action.payload.data ?? {};
    },
    companyGameFetched: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.companyGame = action.payload.data ?? {};
    },
    gameDetailFetched: (state, action) => {
      state.actionsLoading = false;
      state.gameDetail = action.payload.data ?? {};
    },
    gameManaged: (state) => {
      state.actionsLoading = false;
    },
  },
});
